// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3zu7C","errorLogs":"EditorFooter_errorLogs__DYibl"};